import { render, staticRenderFns } from "./InvalidationModal.vue?vue&type=template&id=974a4bda&"
import script from "./InvalidationModal.vue?vue&type=script&lang=js&"
export * from "./InvalidationModal.vue?vue&type=script&lang=js&"
import style0 from "./InvalidationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports